<mat-toolbar class="p-0 mat-elevation-z1">

    <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

        <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

            <button mat-icon-button class="navbar-toggle-button" *ngIf="!hiddenNavbar && !rightNavbar"
                (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

            <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
                <div class="logo ml-16">
                    <img class="logo-icon" src="assets/images/logos/svg/h-logotipo-ll-colorido.svg">
                </div>
            </div>
        </div>

        <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center" fxShow.xs="false">
            <div fxHide fxShow.gt-xs class="ml-20 mr-20" fxLayout="row" fxLayoutAlign="start center" matTooltip="Quantidade de prioridades disponíveis.">
                <mat-icon class="secondary-text">star</mat-icon>
                <span style="padding-left: 10px;">{{qtdPrioridadeDisponivel}}</span>
            </div>
            
            <div fxHide fxShow.gt-xs class="toolbar-separator"></div>

            <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <div fxLayout="row" class="avatar-div">
                        <img class="avatar mr-0 mr-sm-10" src="assets/images/avatars/profile.jpg"
                            style="width: 50px; height: 50px;">
                    </div>
                    <div fxLayout="column" fxLayoutAlign="none start"
                        style="line-height: 16px; padding-top: none; padding-left: 16px;">
                        <div style="line-height: 20px; font-weight: bold;">
                            <span>{{ user.nome }}</span>
                        </div>
                        <div fxLayoutAlign="start center" style="line-height: 10px; font-size: 13px; padding-top: 3px;">
                            <span>{{ user.estabelecimento }}</span>
                        </div>
                    </div>
                    <div fxLayout="row" style="padding-left: 10px;">
                        <mat-icon fxHide.xs>keyboard_arrow_down</mat-icon>
                    </div>
                </div>
            </button>
            <div class="toolbar-separator" fxhide="" fxshow.gt-xs=""></div>
            <button mat-icon-button
                    *ngIf="!somenteUmLocal"
                    class="quick-panel-toggle-button"
                    (click)="toggleSidebarOpen('quickPanel')"
                    aria-label="Toggle quick panel">
                <mat-icon class="icon">account_balance</mat-icon>
            </button>

            <mat-menu #userMenu="matMenu" [overlapTrigger]="false" xPosition="before">                

                <button mat-menu-item [routerLink]="'auth/change-password'">
                    <mat-icon>https</mat-icon>
                    <span>Trocar senha</span>
                </button>

                <button mat-menu-item (click)="logout()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Sair</span>
                </button>
            </mat-menu>
        </div>

        <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center" fxShow.gt-xs="false">
            <div class="toolbar-separator" fxhide="" fxshow.gt-xs=""></div>
            <button mat-button [matMenuTriggerFor]="userMenuMobile" class="user-button">
                <mat-icon class="icon">more_vert</mat-icon>
            </button>

            <mat-menu #userMenuMobile="matMenu" [overlapTrigger]="false" xPosition="before">                
                <button mat-menu-item
                    *ngIf="!somenteUmLocal"
                    class="quick-panel-toggle-button"
                    (click)="toggleSidebarOpen('quickPanel')"
                    aria-label="Toggle quick panel">
                    <mat-icon class="icon">account_balance</mat-icon>
                    <span>Estabelecimento</span>
                </button>
                
                <button mat-menu-item (click)="logout()">
                    <mat-icon>exit_to_app</mat-icon>
                    <span>Logout</span>
                </button>
            </mat-menu>
        </div>
    </div>

</mat-toolbar>